(ns teamoesterreich.user-mode.profile.profile-address-part
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [teamoesterreich.util.log :as log]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.edit :refer [edit]]          ;;(h/event-value e)
    [reagent-material-ui.icons.home :refer [home]]
    [reagent-material-ui.icons.map :refer [map]]
    [reagent.core :as r]
    [teamoesterreich.firebase.provider :as provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.modal.address-modal :as address-modal]
    ))

(def googleGeoCoder (js/google.maps.Geocoder.))

(defn addressComponents-parse [result]
  ;(log/out "addressComponents-parse " result)
  (let [address_components (get (first (js->clj result)) "address_components")
        geometry (get (first (js->clj result)) "geometry")
        lat (.lat ^js (get geometry "location"))
        lng (.lng ^js (get geometry "location"))
        ;_ (log/out "addressComponents-parse geometry "  (.lat (get geometry "location")))
        struct (reduce
                 (fn [c e]
                   ;(log/out "addressComponents-parse part " (clj->js e))
                   (merge c
                          (case (first (get-in e ["types"]))
                            "postal_code" [:zip (get e "long_name")]
                            "locality" [:city (get e "long_name")]
                            "street_number" [:streetNo (get e "long_name")]
                            "route" [:street (get e "long_name")]
                            nil
                            ))

                   ) {} (js->clj address_components))]
    (assoc struct :address (str (:zip struct) " " (:city struct) " " (:street struct) " - " (:streetNo struct))
                  :coordinates (js/firebase.firestore.GeoPoint. lat lng))
    ))


(defn geo-lookup [zip city street street-no cb-fn]
  (log/out "geo-lookup req " zip city street street-no)
  (.geocode googleGeoCoder
            #js {:address (str "" zip " " city ", " street " " street-no)}
            (fn [result status]
              (when (= status "OK")
                (cb-fn (addressComponents-parse result))
                ))))


(defn geo-lookup-enrich-address [!form u-zip u-city u-street u-streetNo]
  (geo-lookup u-zip u-city u-street u-streetNo
              (fn [res]
                (log/out "geo-lookup-result" (clj->js res))
                (swap! !form assoc :main_address
                       (merge res
                              (when (and u-streetNo (not= u-streetNo "")) [:streetNo u-streetNo])
                              ))
                (log/out "geo-lookup-result" (clj->js @!form)
                                ))))



(defn address-view [!actual-user !edit-mode show-open-location]
  (let [fav-locationId (provider/get-fav-locationId)
        !selected-location (r/cursor store/app-state [:state :selected-location])

        u-street (get-in @!actual-user [:main_address :street])
        u-streetNo (get-in @!actual-user [:main_address :streetNo])
        u-zip (get-in @!actual-user [:main_address :zip])
        u-city (get-in @!actual-user [:main_address :city])

        ]

    [mui/grid
     {:container true
      :spacing   4
      }
     [mui/grid
      {:container false
       :item      true
       :xs        12                                        ;extra-small: 0px
       :spacing   4
       }
      [mui/box {:sx {:display "flex" :align-items "baseline" :flex-wrap "wrap"}}
       [:h1 "Hauptadresse"]
       [mui/box {:sx {:flex "1" :height 0 :width "1rem"}}]
       [mui/box {:sx {:display "flex" :align-items "baseline" :gap "1rem" :flex-wrap "wrap"}}
        [mui/button {:style     {:justifyContent "left"}
                     :variant   "contained"
                     :startIcon (r/as-element [edit])
                     :onClick   #(reset! !edit-mode true)
                     }
         "Adresse bearbeiten"]

        (when true #_(and show-open-location fav-locationId)
          [mui/button {
                       :variant   "contained"
                       :startIcon (r/as-element [map])
                       :onClick   (fn []
                                    (reset! !selected-location fav-locationId)
                                    (a/set-page :profile-personal-location-form))
                       }
           "Standort öffnen"])]
       ]
      ]




     [mui/grid
      {:container false
       :item      true
       :md        5                                         ;medium: 960px
       :xs        9                                         ;extra-small: 0px
       :style     {:padding "15px"}
       }
      [mui/text-field {
                       :InputProps   {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [home]])}
                       :fullWidth    true
                       :disabled     true
                       :label        "Postleitzahl ⁽*⁾"
                       :defaultValue (str u-zip)
                       :error        (empty? u-zip)
                       }]
      ]


     [mui/grid
      {:container false
       :item      true
       :md        5                                         ;medium: 960px
       :xs        9                                         ;extra-small: 0px
       :style     {:padding "15px"}
       }
      [mui/text-field {
                       :InputProps   {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [home]])}
                       :fullWidth    true
                       :disabled     true
                       :label        "Ort ⁽*⁾"
                       :defaultValue (str u-city)
                       :error        (empty? u-city)
                       }]
      ]


     [mui/grid
      {:container false
       :item      true
       :md        5                                         ;medium: 960px
       :xs        8                                         ;extra-small: 0px
       :style     {:padding "15px"}
       }
      [mui/text-field {
                       :InputProps   {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [home]])}
                       :fullWidth    true
                       :disabled     true
                       :label        "Straße ⁽*⁾"
                       :defaultValue (str u-street)
                       :error        (empty? u-street)
                       }]
      ]

     [mui/grid
      {:container false
       :item      true
       :md        2                                         ;medium: 960px
       :xs        3                                         ;extra-small: 0px
       :style     {:padding "15px 15px 0 15px"}
       }
      [mui/text-field {
                       :InputProps   {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [home]])}
                       :fullWidth    true
                       :disabled     true
                       :label        "Hausnummer"
                       :defaultValue u-streetNo
                       }]
      ]

     ]))


(defn address-part [!actual-user show-open-location]
  (let [!addr-form (r/atom {:edit-mode false})]
    (fn []
      (let [!edit-mode (r/cursor !addr-form [:edit-mode])]

        [mui/grid
         {:container false
          :item      true
          :xs        12                                     ;extra-small: 0px
          }


         [address-view !actual-user !edit-mode show-open-location]

         [address-modal/address-modal !edit-mode]
         ]
        ))))











